export const REACT_NATIVE_WEBVIEW_SIGNAL = {
  BACK: 'BACK',
  HOME: 'HOME',
  HOTEL_NAVIGATE_TO_BOOKING_DETAIL: 'HOTEL_NAVIGATE_TO_BOOKING_DETAIL',
  BOOKING_CONFIRMATION_PAGE_LOADED: 'BOOKING_CONFIRMATION_PAGE_LOADED',
};
